import { useHookstate } from '@hookstate/core'
import React, { useEffect } from 'react'
import CrudIndex from '~/components/CrudIndex'
import Layout from '~/components/Layout'
import { useLang } from '~/hooks/useLang'

export default function Index() {
  const { translate } = useLang()

  const name = useHookstate<string | null>(null)
  const cityId = useHookstate<number | null>(null)
  const forceRefresh = useHookstate(false)

  useEffect(() => {
    document.title = translate('Administration - Dispatch System')
  }, [])

  const districtFilter = [
    {
      name: 'name',
      type: 'name',
      placeholder: translate('Name'),
      variable: name,
    },
    {
      type: 'city_id',
      variable: cityId,
    },
  ]

  return (
    <Layout marginLayout={true}>
      <CrudIndex
        model="district"
        title="Districts"
        disableColumnsFilters
        viewTitle="district"
        canView={true}
        showInViewMore={['name', 'city:name', 'created_at']}
        forceOrderColumns={['name', 'city:name']}
        notSortable={['city:name']}
        searchButton={() => forceRefresh.set(!forceRefresh.get())}
        forceRefresh={forceRefresh.get()}
        filters={districtFilter}
        clearFilters={() => {
          name.set('')
          cityId.set(null)
          forceRefresh.set(!forceRefresh.get())
        }}
        aliasLabel={[{ column: 'city:name', label: 'City' }]}
      />
    </Layout>
  )
}
